var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-results-tile",
      class: { product: _vm.tileType === "products" }
    },
    [
      _vm.tileType === "products"
        ? _c("product-tile", {
            attrs: {
              simple: true,
              product: _vm.data,
              "selected-variant": _vm.data.variants[0]
            }
          })
        : _vm._e(),
      _vm.tileType === "articles"
        ? _c(
            "a",
            {
              staticClass: "search-results-tile__article",
              attrs: { href: _vm.data.url }
            },
            [
              _c("img", {
                staticClass: "search-results-tile__article-image",
                attrs: { src: _vm.data.image.src, alt: _vm.data.image.alt }
              }),
              _c(
                "div",
                { staticClass: "search-results-tile__article-text" },
                [
                  _c("h6", [_vm._v(_vm._s(_vm.category))]),
                  _c("p", [_vm._v(_vm._s(_vm.data.title))]),
                  _c(
                    "v-link",
                    {
                      staticClass: "link",
                      attrs: { primary: "", href: _vm.data.url }
                    },
                    [_vm._v("View")]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.tileType === "pages"
        ? _c(
            "a",
            {
              staticClass: "search-results-tile__page",
              attrs: { href: _vm.data.url }
            },
            [
              _c(
                "div",
                { staticClass: "search-results-tile__page-text" },
                [
                  _c("h6", [_vm._v("Page")]),
                  _c("p", [_vm._v(_vm._s(_vm.data.title))]),
                  _c(
                    "v-link",
                    {
                      staticClass: "link viewlink",
                      attrs: { primary: "", href: _vm.data.url }
                    },
                    [_vm._v("View")]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }